export default "__VITE_ASSET__DfyT6Dh$__"